module.exports = __webpack_public_path__ + "static/media/cancel.3dd13ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/cancel.svg
// module id = 1283
// module chunks = 0